import { SettingsManager } from "@viamap/viamap2-common";
import { BBR_Bygning, BBR_EjendomsRelation, BBR_Enhed, BBR_Grund, BBR_TekniskAnlæg } from "./BBRTypes";

export class bbrCollector {

   /** Handles SFE EJL og BPFG */
   static async Ejendom_EjendomRelation(BFENummer: string): Promise<BBR_EjendomsRelation> {
      return FetchBBREjendom(BFENummer, "ejendomsRelation");
   }

   /** Handles EJL og BPFG */
   static async Ejendom_Bygning(BFENummer: string): Promise<BBR_Bygning> {
      return FetchBBREjendom(BFENummer, "bygning");
   }

   /** Handles EJL */
   static async Ejendom_Enhed(BFENummer: string): Promise<BBR_Enhed> {
      return FetchBBREjendom(BFENummer, "enhed");
   }

   /** Handles SFE */
   static async Ejendom_Grund(BFENummer: string): Promise<BBR_Grund> {
      return FetchBBREjendom(BFENummer, "grund");
   }

   /** Handles EJL og BPFG */
   static async Ejendom_TekniskAnlæg(BFENummer: string): Promise<BBR_TekniskAnlæg> {
      return FetchBBREjendom(BFENummer, "tekniskanlaeg");
   }

   static async Grund_Bygning(grundID: string): Promise<BBR_Bygning> {
      const params = {
         grund: grundID
      }
      return FetchBBR(params, "bygning")
   }

   static async Bygning_Enhed(bygningID: string): Promise<BBR_Enhed> {
      const params = {
         bygning: bygningID
      }
      return FetchBBR(params, "enhed")
   }

   static async Bygning_TekniskAnlæg(bygningID: string): Promise<BBR_TekniskAnlæg> {
      const params = {
         bygning: bygningID
      }
      return FetchBBR(params, "tekniskanlaeg")
   }

   static async Enhed_TekniskAnlæg(enhedID: string): Promise<BBR_TekniskAnlæg> {
      const params = {
         enhed: enhedID
      }
      return FetchBBR(params, "tekniskanlaeg")
   }

   static async Grund_TekniskAnlæg(grundID: string): Promise<BBR_TekniskAnlæg> {
      const params = {
         grund: grundID
      }
      return FetchBBR(params, "tekniskanlaeg")
   }

   static async getBBRData(BFENummer: string, BFEType: "SFE"): Promise<{ bygning: BBR_Bygning, enhed: BBR_Enhed, grund: BBR_Grund, tekniskanlaeg: BBR_TekniskAnlæg, ejendomsRelation: BBR_EjendomsRelation }>
   static async getBBRData(BFENummer: string, BFEType: "EJL" | "BPFG"): Promise<{ bygning: BBR_Bygning, enhed: BBR_Enhed, tekniskanlaeg: BBR_TekniskAnlæg, ejendomsRelation: BBR_EjendomsRelation }>
   static async getBBRData(BFENummer: string, BFEType: EjendomType): Promise<{ bygning: BBR_Bygning, enhed: BBR_Enhed, grund?: BBR_Grund, tekniskanlaeg: BBR_TekniskAnlæg, ejendomsRelation: BBR_EjendomsRelation }> {
      switch (BFEType) {
         case "EJL": {
            let bygninger = await this.Ejendom_Bygning(BFENummer);
            let enheder = (await Promise.all([
               this.Ejendom_Enhed(BFENummer),
               bygninger.map((b) => this.Bygning_Enhed(b.id_lokalId!))
            ].flat())).flat();
            let teknik = (await Promise.all([
               enheder.map((c) => this.Enhed_TekniskAnlæg(c.id_lokalId!)),
               bygninger.map((b) => this.Bygning_TekniskAnlæg(b.id_lokalId!))
            ].flat())).flat();
            return {
               bygning: bygninger as BBR_Bygning,
               enhed: enheder as BBR_Enhed,
               tekniskanlaeg: teknik as BBR_TekniskAnlæg,
               ejendomsRelation: await this.Ejendom_EjendomRelation(BFENummer)
            }
         }
         case "SFE": {
            let grunde = await this.Ejendom_Grund(BFENummer);
            let bygninger = (await Promise.all(grunde.map((a) => this.Grund_Bygning(a.id_lokalId!)))).flat();
            let enheder = (await Promise.all(bygninger.map((b) => this.Bygning_Enhed(b.id_lokalId!)))).flat();
            let teknik = (await Promise.all([
               grunde.map((a) => this.Grund_TekniskAnlæg(a.id_lokalId!)),
               bygninger.map((b) => this.Bygning_TekniskAnlæg(b.id_lokalId!)),
               enheder.map((c) => this.Enhed_TekniskAnlæg(c.id_lokalId!)),
            ].flat())).flat();
            return {
               grund: grunde as BBR_Grund,
               bygning: bygninger as BBR_Bygning,
               enhed: enheder as BBR_Enhed,
               tekniskanlaeg: teknik as BBR_TekniskAnlæg,
               ejendomsRelation: await this.Ejendom_EjendomRelation(BFENummer)
            }
         }
         case "BPFG": {
            let bygninger = await this.Ejendom_Bygning(BFENummer);
            let teknikBygninger = await this.Bygning_TekniskAnlæg(bygninger.map((b) => b.id_lokalId).join("|"));
            let enheder = await this.Bygning_Enhed(bygninger.map((b) => b.id_lokalId).join("|"));
            let teknikEnheder = await this.Enhed_TekniskAnlæg(enheder.map((c) => c.id_lokalId).join("|"));
            return {
               bygning: bygninger as BBR_Bygning,
               enhed: enheder as BBR_Enhed,
               tekniskanlaeg: [...teknikEnheder, ...teknikBygninger] as BBR_TekniskAnlæg,
               ejendomsRelation: await this.Ejendom_EjendomRelation(BFENummer)
            }
         }

      }
   }
}






type EjendomType = "EJL" | "BPFG" | "SFE";
type BBRTypes = "bygning" | "enhed" | "grund" | "tekniskanlaeg" | "ejendomsRelation";
type BBRTypesReturn = {
   bygning: BBR_Bygning;
   enhed: BBR_Enhed;
   grund: BBR_Grund;
   tekniskanlaeg: BBR_TekniskAnlæg;
   ejendomsRelation: BBR_EjendomsRelation;
}


function FetchBBR<T extends BBRTypes>(inParams: { [key: string]: any }, type: T): Promise<BBRTypesReturn[T]> {
   const serviceUrl = "https://services.datafordeler.dk/BBR/BBRPublic/1/rest/" + type
   const params = {
      ...inParams,
      username: SettingsManager.getSystemSetting("datafordelerUsername"),
      password: SettingsManager.getSystemSetting("datafordelerPassword"),
   }
   return fetch(serviceUrl + `?${new URLSearchParams(params)}`, {
      method: 'GET',
      headers: {
         'Accept': 'application/json'
      }
   }).then(async res => {
      if (!res.ok) {
         await res.text().then(text => {
            console.error("Error response from Mat2:", text);
         });
         throw new Error(`HTTP error! status: ${res.status}`);
      }
      return res.json() as Promise<BBRTypesReturn[typeof type]>;
   });

}

function FetchBBREjendom<T extends BBRTypes>(BFENummer: string, type: T): Promise<BBRTypesReturn[T]> {
   const params = {
      BFENummer: BFENummer,
   }
   return FetchBBR(params, type)
}

